import React, { FC } from "react";

import dayjs from "dayjs";
import { Trans, useTranslation } from "react-i18next";

import { useBalance } from "@api";

import { Modal } from "@ui/components";
import { Button, Icon, Text, Title } from "@ui/elements";
import { Stack } from "@ui/layout";

import {
  TranslationConsumer,
  useTranslationContext,
} from "../TranslationProvider";

type FailedUnlockModalProps = {
  onClose: (openSecondModal?: boolean) => void;
  open: boolean;
};

export const FailedUnlockModal: FC<FailedUnlockModalProps> = ({
  onClose,
  open,
}) => {
  const { locale } = useTranslationContext();
  const { data: balanceData } = useBalance();
  const { t } = useTranslation();

  return (
    <Modal
      isActive={open}
      onClose={() => onClose(false)}
      header={
        <Stack align="center">
          <Icon icon="LockSimple" />
          <Title size={4}>{t("messages.oh-no")}</Title>
        </Stack>
      }
      style={{ zIndex: 100 }}
      footer={
        <Stack justify="end" isFullwidth>
          <Button variant="light" onClick={() => onClose(false)}>
            {t("labels.cancel")}
          </Button>
          <Button color="primary" onClick={() => onClose(true)}>
            {t("labels.view-plans")}
          </Button>
        </Stack>
      }
    >
      <Stack direction="column" gap="xl">
        <Stack direction="column" gap="xl">
          <Title size={6}>
            {t("messages.maximum-free-unlock-1", {
              num: balanceData?.max_free_analysis || 3,
            })}
          </Title>
          <TranslationConsumer>
            {() => (
              <Text>
                <Trans
                  i18nKey="messages.maximum-free-unlock-2"
                  values={{
                    date: dayjs(balanceData?.next_unlock_date)
                      .locale(locale)
                      .format("LLL"),
                  }}
                />
              </Text>
            )}
          </TranslationConsumer>
        </Stack>
      </Stack>
    </Modal>
  );
};
